import { IconButton } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { useStores } from 'stores/rootStore';
import { FilterIcon } from 'vectors';

const ToggleFilters = () => {
  const { marketPlaceStore } = useStores();

  const handleToggleFilters = useCallback(() => {
    marketPlaceStore.toggleMarketplaceFilters();
  }, [marketPlaceStore]);

  return (
    <IconButton
      _hover={{
        backgroundColor: 'button.secondary.hover',
      }}
      onClick={handleToggleFilters}
      variant="ghost"
      px={2}
    >
      {marketPlaceStore.isMarketplaceFiltersOpen ? 'Hide filters' : 'Show filters'}
      <FilterIcon />
    </IconButton>
  );
};

export default observer(ToggleFilters);
